import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Pillars from "../components/Pillars";
import Diagnostic from "../components/Diagnostic";
import SuccessProfile from "../components/SuccessProfile";
import Footer from "../components/Footer";

export default function Home({ onOpenModal }) {
  return (
    <div className="appShell">
      <Navbar onOpenModal={onOpenModal} />
      <main>
        <Hero onOpenModal={onOpenModal} />
        <Pillars onOpenModal={onOpenModal} />
        <SuccessProfile />
        <Diagnostic />
      </main>
      <Footer />
    </div>
  );
}
